/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { userDetail } from '../../stores/userDetail';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';

class InputBoxPopupState {
  @observable showPopup = false;

  defaultPopupValue = {
    title: '',
    inputBoxArr: [],
    actionBtnText: '',
    callback() {
      console.log('callback');
    },
  };

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName('body')[0].classList.add('scrollHidden');
    } else {
      this.popupValues = this.defaultPopupValue;
      document.getElementsByTagName('body')[0].classList.remove('scrollHidden');
    }
  };

  @action
  setPopupValues = val => {
    this.popupValues = val;
    // {
    //   title: val.title ? val.title : this.popupValues.title,
    // };
  };
}

const inputBoxPopupState = new InputBoxPopupState();

const InputBoxPopup = observer(props => {
  const defaultInputState = {
    name: '',
    cpassword: '',
    npassword: '',
    concpassword: '',
    timezone: '',
    fname: '',
    lname: '',
    email: '',
  };
  const [inputVal, setInputVal] = React.useState(defaultInputState);
  // const [errorToolTip, showErrorToolTip] = React.useState(false);

  // const [errorTextObj, setErrorTextObj] = React.useState({});

  const changeInputVal = e => {
    const { currentTarget } = e;
    const { value, id } = currentTarget;
    const stateObj = { ...inputVal };
    stateObj[id] = value;
    // showErrorToolTip(false);
    setInputVal(stateObj);
  };

  React.useEffect(() => {
    const obj = inputVal;
    obj.timezone =
      userDetail.userInfo && userDetail.userInfo.timeZone
        ? userDetail.userInfo.timeZone.zone_value +
          userDetail.userInfo.timeZone.zone_name
        : '';
    setInputVal(obj);
  }, [userDetail.userInfo]);

  const submitAction = e => {
    e.preventDefault();
    // eslint-disable-next-line no-undef
    const isErrorShown = document.getElementsByClassName('errorShown').length;
    if (isErrorShown === 0) {
      // showErrorToolTip(false);
      inputBoxPopupState.popupValues.callback(inputVal);
      setInputVal(defaultInputState);
    }
  };

  return inputBoxPopupState.showPopup ? (
    <>
      <div className="confirmation-popup common-popup input-popup">
        <form className="popup-wrap" onSubmit={submitAction} autoComplete="off">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => inputBoxPopupState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>
          {inputBoxPopupState.popupValues.title && (
            <div className="title">{inputBoxPopupState.popupValues.title}</div>
          )}
          <div>
            {inputBoxPopupState.popupValues.inputBoxArr &&
            inputBoxPopupState.popupValues.inputBoxArr.length
              ? inputBoxPopupState.popupValues.inputBoxArr.map(
                  (inputObj, key) => {
                    return (
                      <div key={key} className="popup-content-wrap">
                        {inputObj.type === 'select' ? (
                          <select
                            id={inputObj.id}
                            onChange={e => changeInputVal(e)}
                            value={inputVal[inputObj.id]}
                          >
                            {inputObj.options &&
                              inputObj.options.map((option, idx) => {
                                return (
                                  <option key={idx} value={option}>
                                    {option}
                                  </option>
                                );
                              })}
                          </select>
                        ) : (
                          <input
                            type={inputObj.type}
                            id={inputObj.id}
                            className="input-box"
                            placeholder={inputObj.placeholder}
                            value={inputVal[inputObj.id]}
                            onChange={e => changeInputVal(e)}
                            autoComplete="new-password"
                            required
                            onBlur={
                              inputObj.onblurCallback
                                ? e => inputObj.onblurCallback(inputVal, e)
                                : e => {
                                    console.log('empty Blur Fun');
                                  }
                            }
                          />
                        )}
                        <div
                          className="profileErrorMsg"
                          id={`err${inputObj.id}`}
                        >
                          <span className="top-arrow" />
                          <span>
                            {inputObj.errorMsg ? inputObj.errorMsg : ''}
                          </span>
                        </div>
                      </div>
                    );
                  },
                )
              : ''}
          </div>
          <div className="popup-action-wrap">
            <button type="submit" className="popup-action-btn positive-btn">
              {inputBoxPopupState.popupValues.actionBtnText}
            </button>
            <div
              className="popup-action-btn"
              onClick={() => inputBoxPopupState.setShowPopup(false)}
            >
              Cancel
            </div>
          </div>
        </form>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => inputBoxPopupState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export { InputBoxPopup, inputBoxPopupState };
export default InputBoxPopup;
